import { render, staticRenderFns } from "./DenyAccess.vue?vue&type=template&id=40ad4aa9&scoped=true&"
import script from "./DenyAccess.vue?vue&type=script&lang=js&"
export * from "./DenyAccess.vue?vue&type=script&lang=js&"
import style0 from "./DenyAccess.vue?vue&type=style&index=0&id=40ad4aa9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ad4aa9",
  null
  
)

export default component.exports